import { Col, Row } from '@thd-olt-component-react/core-ui';
import React from 'react';
import { bool } from 'prop-types';
import { SubmenuBar, SubmenuItem } from './submenu/SubmenuComponent';

export const PrivacySubMenu = ({ atAGlanceActive, privacyStatementActive, reportsActive }) => {
  return (
    <Row>
      <Col className="remove-padding">
        <ul className="submenu-bar">
          <SubmenuBar classnames={{ 'submenu-bar': true }}>
            <>
              <SubmenuItem
                title="Privacy & Security at a Glance"
                link="/privacy/privacy-and-security-at-a-glance"
                active={atAGlanceActive}
              />
              <SubmenuItem
                title="Privacy & Security Statement"
                link="/privacy/privacy-and-security-statement"
                active={privacyStatementActive}
              />
              <SubmenuItem
                title="California Privacy Rights & Report"
                link="/privacy/California-Privacy-Rights-and-Report"
                active={reportsActive}
              />
            </>
          </SubmenuBar>
        </ul>
      </Col>
    </Row>
  );
};

PrivacySubMenu.propTypes = {
  atAGlanceActive: bool,
  privacyStatementActive: bool,
  reportsActive: bool
};

PrivacySubMenu.defaultProps = {
  atAGlanceActive: false,
  privacyStatementActive: false,
  reportsActive: false
};
